export function IconHolder({
  className = '',
  children,
}: {
  className?: string
  children: React.ReactNode
}) {
  return (
    <div
      className={`flex justify-center items-center rounded-full bg-[#a5aedd]/20 aspect-square ${className}`}
    >
      {children}
    </div>
  )
}
